import React, { useState, useEffect } from 'react';
import { useApi } from '../../../hooks/useApi';
import logger from "../../../utils/logger";
import EntityCell from '../EntityCell';
import { matchesSearch } from '../../../utils/search';
// Списки админки отдаются страницами: забираем все, а не первые 100/1000.
async function loadAllPages(request, path, { pageSize = 200, offsetParam = 'offset' } = {}) {
  const rows = [];
  for (let offset = 0; ; offset += pageSize) {
    const sep = path.includes('?') ? '&' : '?';
    const page = (await request(`${path}${sep}limit=${pageSize}&${offsetParam}=${offset}`)) || [];
    rows.push(...page);
    if (page.length < pageSize) return rows;
  }
}

function AdminWorkspaces() {
  const {
    request,
    showStatus
  } = useApi();
  const [workspaces, setWorkspaces] = useState([]);
  const [loading, setLoading] = useState(false);
  const [activeWorkspace, setActiveWorkspace] = useState(null);
  const [activeTab, setActiveTab] = useState('general'); // general, members, cabinets
  const [editForm, setEditForm] = useState({
    name: ''
  });

  // Data for members/cabinets
  const [members, setMembers] = useState([]);
  const [linkedCabinets, setLinkedCabinets] = useState([]);
  const [allUsers, setAllUsers] = useState([]);
  const [allCabinets, setAllCabinets] = useState([]);
  const [userSearchText, setUserSearchText] = useState('');
  const [cabinetSearchText, setCabinetSearchText] = useState('');
  useEffect(() => {
    loadWorkspaces();
    loadCatalogData();
  }, []);
  const loadWorkspaces = async () => {
    setLoading(true);
    try {
      const data = await loadAllPages(request, '/api/v1/admin/workspaces');
      setWorkspaces(data || []);
    } catch (error) {
      logger.error(error);
    } finally {
      setLoading(false);
    }
  };
  const loadCatalogData = async () => {
    try {
      const users = await loadAllPages(request, '/api/v1/users/', { pageSize: 1000, offsetParam: 'skip' });
      setAllUsers(users || []);
      const cabinets = await loadAllPages(request, '/api/v1/admin/marketplaces');
      setAllCabinets(cabinets || []);
    } catch (e) {
      logger.error(e);
    }
  };
  const handleManage = async ws => {
    setActiveWorkspace(ws);
    setEditForm({
      name: ws.name || ''
    });
    setActiveTab('general');
    loadWorkspaceDetails(ws.id);
  };
  const loadWorkspaceDetails = async id => {
    try {
      const m = await request(`/api/v1/admin/workspaces/${id}/members`);
      setMembers(m || []);
      const c = await request(`/api/v1/admin/workspaces/${id}/cabinets`);
      setLinkedCabinets(c || []);
    } catch (e) {
      logger.error(e);
    }
  };
  const handleSaveGeneral = async () => {
    try {
      await request(`/api/v1/admin/workspaces/${activeWorkspace.id}`, {
        method: 'PATCH',
        body: JSON.stringify(editForm)
      });
      showStatus('success', 'Данные проекта обновлены');
      loadWorkspaces();
    } catch (e) {
      showStatus('error', 'Ошибка сохранения');
    }
  };
  const handleAddMember = async userId => {
    try {
      await request(`/api/v1/admin/workspaces/${activeWorkspace.id}/members`, {
        method: 'POST',
        body: JSON.stringify({
          user_id: userId,
          role: 'manager'
        })
      });
      showStatus('success', 'Участник добавлен');
      loadWorkspaceDetails(activeWorkspace.id);
    } catch (e) {
      showStatus('error', 'Ошибка');
    }
  };
  const handleRemoveMember = async memberId => {
    if (!window.confirm('Убрать участника из проекта?')) return;
    try {
      await request(`/api/v1/admin/workspace-members/${memberId}`, {
        method: 'DELETE'
      });
      showStatus('success', 'Участник удален');
      loadWorkspaceDetails(activeWorkspace.id);
    } catch (e) {
      showStatus('error', 'Ошибка');
    }
  };
  const handleLinkCabinet = async cabinetId => {
    try {
      await request(`/api/v1/admin/workspaces/${activeWorkspace.id}/cabinets`, {
        method: 'POST',
        body: JSON.stringify({
          cabinet_id: cabinetId
        })
      });
      showStatus('success', 'Кабинет привязан');
      loadWorkspaceDetails(activeWorkspace.id);
    } catch (e) {
      showStatus('error', 'Ошибка');
    }
  };
  const handleUnlinkCabinet = async linkId => {
    if (!window.confirm('Отвязать кабинет от проекта?')) return;
    try {
      await request(`/api/v1/admin/workspace-cabinets/${linkId}`, {
        method: 'DELETE'
      });
      showStatus('success', 'Кабинет отвязан');
      loadWorkspaceDetails(activeWorkspace.id);
    } catch (e) {
      showStatus('error', 'Ошибка');
    }
  };
  const handleDeleteWorkspace = async id => {
    if (!window.confirm('Удалить проект? Все связи будут разорваны.')) return;
    try {
      await request(`/api/v1/admin/workspaces/${id}`, {
        method: 'DELETE'
      });
      showStatus('success', 'Проект удален');
      loadWorkspaces();
    } catch (e) {
      showStatus('error', 'Ошибка');
    }
  };
  return <div className="admin-page">
            <div style={{
      display: 'flex',
      justifyContent: 'space-between',
      marginBottom: '20px'
    }}>
                <h1>Проекты (Workspace)</h1>
            </div>

            {/* Manage Modal */}
            {activeWorkspace && <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      background: 'rgba(0,0,0,0.5)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 1000
    }}>
                    <div style={{
        background: 'white',
        padding: '0',
        borderRadius: '12px',
        width: '800px',
        maxWidth: '95%',
        height: '80vh',
        display: 'flex',
        flexDirection: 'column'
      }}>
                        <div style={{
          padding: '20px',
          borderBottom: '1px solid #eee',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center'
        }}>
                            <h2 style={{
            margin: 0
          }}>Управление проектом: {activeWorkspace.name}</h2>
                            <button onClick={() => setActiveWorkspace(null)} style={{
            background: 'none',
            border: 'none',
            fontSize: '24px',
            cursor: 'pointer'
          }}>&times;</button>
                        </div>

                        {/* Tabs Navigation */}
                        <div style={{
          display: 'flex',
          background: '#f8f9fa',
          borderBottom: '1px solid #eee'
        }}>
                            <button onClick={() => setActiveTab('general')} style={{
            padding: '15px 25px',
            border: 'none',
            borderBottom: activeTab === 'general' ? '3px solid #3498db' : 'none',
            background: 'none',
            cursor: 'pointer',
            fontWeight: activeTab === 'general' ? 'bold' : 'normal'
          }}>Общие</button>
                            <button onClick={() => setActiveTab('members')} style={{
            padding: '15px 25px',
            border: 'none',
            borderBottom: activeTab === 'members' ? '3px solid #3498db' : 'none',
            background: 'none',
            cursor: 'pointer',
            fontWeight: activeTab === 'members' ? 'bold' : 'normal'
          }}>Сотрудники ({members.length})</button>
                            <button onClick={() => setActiveTab('cabinets')} style={{
            padding: '15px 25px',
            border: 'none',
            borderBottom: activeTab === 'cabinets' ? '3px solid #3498db' : 'none',
            background: 'none',
            cursor: 'pointer',
            fontWeight: activeTab === 'cabinets' ? 'bold' : 'normal'
          }}>Кабинеты ({linkedCabinets.length})</button>
                        </div>

                        <div style={{
          flex: 1,
          overflowY: 'auto',
          padding: '20px'
        }}>
                            {activeTab === 'general' && <div>
                                    <div style={{
              marginBottom: '15px'
            }}>
                                        <label style={{
                display: 'block',
                fontWeight: 'bold'
              }}>Название</label>
                                        <input type="text" value={editForm.name} onChange={e => setEditForm({
                ...editForm,
                name: e.target.value
              })} style={{
                width: '100%',
                padding: '10px',
                marginTop: '5px',
                border: '1px solid #ddd',
                borderRadius: '4px'
              }} />
                                    </div>
                                    <div style={{
              marginBottom: '15px'
            }}>
                                        <label style={{
                display: 'block',
                fontWeight: 'bold'
              }}>Owner ID</label>
                                        <input type="text" value={activeWorkspace.owner_user_id} disabled style={{
                width: '100%',
                padding: '10px',
                marginTop: '5px',
                background: '#f5f5f5',
                border: '1px solid #ddd',
                borderRadius: '4px'
              }} />
                                    </div>
                                    <button onClick={handleSaveGeneral} style={{
              padding: '12px 25px',
              background: '#3498db',
              color: 'white',
              border: 'none',
              borderRadius: '6px',
              cursor: 'pointer',
              fontWeight: 'bold',
              marginTop: '10px'
            }}>Сохранить изменения</button>
                                </div>}

                            {activeTab === 'members' && <div>
                                    <div style={{
              marginBottom: '20px',
              padding: '15px',
              background: '#eef2f7',
              borderRadius: '8px'
            }}>
                                        <label style={{
                display: 'block',
                marginBottom: '10px',
                fontWeight: 'bold'
              }}>Добавить сотрудника</label>
                                        <div style={{
                display: 'flex',
                gap: '10px',
                marginBottom: '10px'
              }}>
                                            <input type="text" placeholder="Поиск пользователя..." value={userSearchText} onChange={e => setUserSearchText(e.target.value)} style={{
                  flex: 1,
                  padding: '8px',
                  borderRadius: '4px',
                  border: '1px solid #ddd'
                }} />
                  
                                        </div>
                                        <div style={{
                display: 'flex',
                gap: '10px'
              }}>
                                            <select id="userSelect" style={{
                  flex: 1,
                  padding: '10px',
                  borderRadius: '4px',
                  border: '1px solid #ddd'
                }}>
                                                <option value="">Выберите пользователя...</option>
                                                {allUsers.filter(u => !members.some(m => m.user_id === u.id)).filter(u => matchesSearch(u, userSearchText)).slice(0, 50).map(u => <option key={u.id} value={u.id}>{u.email} ({u.first_name})</option>)}
                                            </select>
                                            <button onClick={() => {
                  const val = document.getElementById('userSelect').value;
                  if (val) handleAddMember(val);
                }} style={{
                  padding: '10px 20px',
                  background: '#27ae60',
                  color: 'white',
                  border: 'none',
                  borderRadius: '4px',
                  cursor: 'pointer'
                }}>Добавить</button>
                                        </div>
                                    </div>

                                    <table style={{
              width: '100%',
              borderCollapse: 'collapse'
            }}>
                                        <thead style={{
                background: '#f8f9fa'
              }}>
                                            <tr>
                                                <th style={{
                    padding: '10px',
                    textAlign: 'left'
                  }}>Email / Имя</th>
                                                <th style={{
                    padding: '10px',
                    textAlign: 'center'
                  }}>Роль</th>
                                                <th style={{
                    padding: '10px',
                    textAlign: 'right'
                  }}>Действие</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {members.map(m => <tr key={m.id} style={{
                  borderBottom: '1px solid #eee'
                }}>
                                                    <td style={{
                    padding: '10px'
                  }}>
                                                        <div>{m.email}</div>
                                                        <div style={{
                      fontSize: '12px',
                      color: '#888'
                    }}>{m.first_name} {m.last_name}</div>
                                                    </td>
                                                    <td style={{
                    padding: '10px',
                    textAlign: 'center'
                  }}>
                                                        <span style={{
                      fontSize: '12px',
                      background: '#eee',
                      padding: '2px 6px',
                      borderRadius: '4px'
                    }}>{m.role}</span>
                                                    </td>
                                                    <td style={{
                    padding: '10px',
                    textAlign: 'right'
                  }}>
                                                        <button onClick={() => handleRemoveMember(m.id)} style={{
                      color: '#e74c3c',
                      background: 'none',
                      border: 'none',
                      cursor: 'pointer'
                    }}>Удалить</button>
                                                    </td>
                                                </tr>)}
                                        </tbody>
                                    </table>
                                </div>}

                            {activeTab === 'cabinets' && <div>
                                    <div style={{
              marginBottom: '20px',
              padding: '15px',
              background: '#eef2f7',
              borderRadius: '8px'
            }}>
                                        <label style={{
                display: 'block',
                marginBottom: '10px',
                fontWeight: 'bold'
              }}>Привязать кабинет</label>
                                        <div style={{
                display: 'flex',
                gap: '10px',
                marginBottom: '10px'
              }}>
                                            <input type="text" placeholder="Поиск кабинета..." value={cabinetSearchText} onChange={e => setCabinetSearchText(e.target.value)} style={{
                  flex: 1,
                  padding: '8px',
                  borderRadius: '4px',
                  border: '1px solid #ddd'
                }} />
                  
                                        </div>
                                        <div style={{
                display: 'flex',
                gap: '10px'
              }}>
                                            <select id="cabinetSelect" style={{
                  flex: 1,
                  padding: '10px',
                  borderRadius: '4px',
                  border: '1px solid #ddd'
                }}>
                                                <option value="">Выберите кабинет...</option>
                                                {allCabinets.filter(c => !linkedCabinets.some(lc => lc.cabinet_id === c.id)).filter(c => matchesSearch(c, cabinetSearchText)).slice(0, 50).map(c => <option key={c.id} value={c.id}>{c.account_name} ({c.marketplace_type})</option>)}
                                            </select>
                                            <button onClick={() => {
                  const val = document.getElementById('cabinetSelect').value;
                  if (val) handleLinkCabinet(val);
                }} style={{
                  padding: '10px 20px',
                  background: '#27ae60',
                  color: 'white',
                  border: 'none',
                  borderRadius: '4px',
                  cursor: 'pointer'
                }}>Привязать</button>
                                        </div>
                                    </div>

                                    <table style={{
              width: '100%',
              borderCollapse: 'collapse'
            }}>
                                        <thead style={{
                background: '#f8f9fa'
              }}>
                                            <tr>
                                                <th style={{
                    padding: '10px',
                    textAlign: 'left'
                  }}>Название</th>
                                                <th style={{
                    padding: '10px',
                    textAlign: 'center'
                  }}>Тип</th>
                                                <th style={{
                    padding: '10px',
                    textAlign: 'right'
                  }}>Действие</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {linkedCabinets.map(c => <tr key={c.id} style={{
                  borderBottom: '1px solid #eee'
                }}>
                                                    <td style={{
                    padding: '10px'
                  }}>{c.account_name}</td>
                                                    <td style={{
                    padding: '10px',
                    textAlign: 'center'
                  }}>{c.marketplace_type}</td>
                                                    <td style={{
                    padding: '10px',
                    textAlign: 'right'
                  }}>
                                                        <button onClick={() => handleUnlinkCabinet(c.id)} style={{
                      color: '#e74c3c',
                      background: 'none',
                      border: 'none',
                      cursor: 'pointer'
                    }}>Отвязать</button>
                                                    </td>
                                                </tr>)}
                                        </tbody>
                                    </table>
                                </div>}
                        </div>
                    </div>
                </div>}

            <div style={{
      background: 'white',
      borderRadius: '12px',
      boxShadow: '0 4px 6px rgba(0,0,0,0.05)',
      overflow: 'hidden'
    }}>
                <table style={{
        width: '100%',
        borderCollapse: 'collapse'
      }}>
                    <thead style={{
          background: '#fcfcfc',
          borderBottom: '2px solid #eee'
        }}>
                        <tr>
                            <th style={{
              padding: '15px',
              textAlign: 'left'
            }}>Название проекта</th>
                            <th style={{
              padding: '15px',
              textAlign: 'left'
            }}>Владелец</th>
                            <th style={{
              padding: '15px',
              textAlign: 'right'
            }}>Действия</th>
                        </tr>
                    </thead>
                    <tbody>
                        {loading && <tr><td colSpan="3" style={{
              padding: '40px',
              textAlign: 'center'
            }}>Загрузка...</td></tr>}
                        {workspaces.map(ws => <tr key={ws.id} style={{
            borderBottom: '1px solid #f5f5f5'
          }}>
                                <td style={{
              padding: '15px'
            }}>
                                    <EntityCell name={ws.name} owner={ws.owner_email} id={ws.id} />
                                </td>
                                <td style={{
              padding: '15px'
            }}>
                                    <div style={{
                fontSize: '13px'
              }}>{ws.owner_email || '—'}</div>
                                    <div style={{
                fontSize: '12px',
                color: '#999'
              }}>{ws.owner_user_id}</div>
                                </td>
                                <td style={{
              padding: '15px',
              textAlign: 'right'
            }}>
                                    <button onClick={() => handleManage(ws)} style={{
                marginRight: '10px',
                padding: '6px 12px',
                borderRadius: '4px',
                border: '1px solid #3498db',
                color: '#3498db',
                background: 'white',
                cursor: 'pointer'
              }}>
                                        Управление
                                    </button>
                                    <button onClick={() => handleDeleteWorkspace(ws.id)} style={{
                color: '#e74c3c',
                background: 'none',
                border: 'none',
                cursor: 'pointer'
              }}>
                                        Удалить
                                    </button>
                                </td>
                            </tr>)}
                    </tbody>
                </table>
            </div>
        </div>;
}
export default AdminWorkspaces;
